// src/pages/MealDetails.js

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../../shared/components/layout/Layout';
import { Alert } from '../../../shared/components/ui';
import MealDetailView from '../components/MealDetailView';
import { recipeService } from '../services/recipeService';
import { useTranslation } from 'react-i18next';

const MealDetails = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [meal, setMeal] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (id) {
            loadMealDetails();
        }
    }, [id]);

    const loadMealDetails = async () => {
        setIsLoading(true);
        setError('');

        try {
            const result = await recipeService.getRecipeById(id);
            if (result.success) {
                setMeal(result.recipe);
            } else {
                setError(t('meal.details.loadError') || t('common.error'));
            }
        } catch (err) {
            setError(err.message || t('meal.details.loadError') || t('common.error'));
        } finally {
            setIsLoading(false);
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    if (isLoading) {
        return (
            <Layout title={t('meal.details.title')}>
                <div className="max-w-4xl mx-auto p-6">
                    <Alert variant="info" className="text-center">
                        <p>{t('meal.details.loading') || t('common.loading')}</p>
                    </Alert>
                </div>
            </Layout>
        );
    }

    if (error) {
        return (
            <Layout title={t('common.error')}>
                <div className="max-w-4xl mx-auto p-6">
                    <Alert variant="error">
                        <p>{error}</p>
                        <button
                            onClick={loadMealDetails}
                            className="mt-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
                        >
                            {t('common.retry') || 'Reintentar'}
                        </button>
                    </Alert>
                </div>
            </Layout>
        );
    }

    if (!meal) {
        return (
            <Layout title={t('meal.details.notFound') || t('common.error')}>
                <div className="max-w-4xl mx-auto p-6">
                    <Alert variant="warning">
                        <p>{t('meal.details.notFound') || t('common.error')}</p>
                        <button
                            onClick={handleBack}
                            className="mt-2 px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition-colors"
                        >
                            {t('common.back')}
                        </button>
                    </Alert>
                </div>
            </Layout>
        );
    }

    return (
        <Layout title={`${meal.name} - ${t('meal.details.title')}` }>
            <div className="max-w-4xl mx-auto p-6">
                <MealDetailView
                    meal={meal}
                    showBackButton={true}
                    onBack={handleBack}
                    onRecipeUpdated={setMeal}
                />
            </div>
        </Layout>
    );
};

export default MealDetails;
